import SwitchContainer from "../../../../components/formsAndTable/forms/formWidgets/switch";

const Switch = () => {
  return <SwitchContainer />;
};

export default Switch;
